module.exports = __webpack_public_path__ + "img/14g-doc-acao-manutencao.ba2b0eaf.png";